import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://paymentsapi.steponexp.com/api',
  timeout: 30000,
});

// Attach token to every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally — fire event so AuthContext clears React state cleanly
API.interceptors.response.use(
  (res) => res,
  (err) => {
    const is401        = err.response?.status === 401;
    const onStatusPage = window.location.pathname.startsWith('/payment/status');

    if (is401 && !onStatusPage) {
      window.dispatchEvent(new Event('auth:logout'));
    }

    return Promise.reject(err);
  }
);

export default API;